import { Option, RadioField } from "../types";
import { RadioFormControlLabel } from "@kaltura/ds-react-components";
import { Container, StyledFormLabel } from "@kaltura/mediaspace-shared-ui/controlled-form";
import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import { styled } from "@mui/material";
import RadioGroupMui from "@mui/material/RadioGroup";
import { flexGap } from "./styled-components";
import { FormLabelWithDescription } from "@kaltura/mediaspace-shared-ui/form";

export interface RadioGroupProps {
    field: RadioField;
}

export const RadioGroup = ({ field }: RadioGroupProps) => {
    const { label, id, required, options } = field;
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const getRadioLabel = (option: Option) => {
        return option.description ? (
            <StyledLabel text={option.label} description={option.description} fontWeightBold={true} infoIconSize={16} />
        ) : (
            option.label
        );
    };

    return (
        <Container>
            <StyledFormLabel htmlFor={id} required={required} text={label} fontWeightBold={true} />
            <div>
                <Controller
                    control={control}
                    name={id}
                    rules={{ required }}
                    render={({ field }) => (
                        <StyledRadioGroup
                            value={field.value ?? options?.[0]?.value}
                            onChange={(event) => field.onChange(event.target.value)}
                            name={`radio-buttons-group-${id}`}
                            id={id}
                        >
                            {options?.map((item, index) => (
                                <RadioFormControlLabel key={index} label={getRadioLabel(item)} value={item.value} />
                            ))}
                        </StyledRadioGroup>
                    )}
                />
            </div>
        </Container>
    );
};

const StyledRadioGroup = styled(RadioGroupMui)(({ theme }) => ({
    ...flexGap(theme),
}));

const StyledLabel = styled(FormLabelWithDescription)(({ theme }) => ({
    color: theme.kaltura.palette.tone4,
}));
